const filterMapping = {
  pk10: {
    singleBallData: ['冠军', '亚军', '第三名', '第四名', '第五名', '第六名', '第七名', '第八名', '第九名', '第十名'],
    singleTypeData: ['单双', '大小', '龙虎'],
    ballData: ['hm1', 'hm2', 'hm3', 'hm4', 'hm5', 'hm6', 'hm7', 'hm8', 'hm9', 'hm10', 'sumguanya'],
    typeData: ['hmDanShuang', 'hmDaXiao', 'zuLongHu'],
    ballText: [
      { name: '冠军', val: 'hm1' },
      { name: '亚军', val: 'hm2' },
      { name: '第三名', val: 'hm3' },
      { name: '第四名', val: 'hm4' },
      { name: '第五名', val: 'hm5' },
      { name: '第六名', val: 'hm6' },
      { name: '第七名', val: 'hm7' },
      { name: '第八名', val: 'hm8' },
      { name: '第九名', val: 'hm9' },
      { name: '第十名', val: 'hm10' }

    ],
    typeText: [
      { name: '单双', val: 'hmDanShuang' },
      { name: '大小', val: 'hmDaXiao' },
      { name: '龙虎', val: 'zuLongHu' }
    ],
    singleBall: '冠军',
    singleType: '大小'
  },
  ssc: {
    singleBallData: ['第一球', '第二球', '第三球', '第四球', '第五球', '总和'],
    singleTypeData: ['大小', '单双', '龙虎'],
    ballData: ['hm1', 'hm2', 'hm3', 'hm4', 'hm5', 'all', 'allmantissa'],
    typeData: ['hmDanShuang', 'hmDaXiao', 'longHu', 'zongHeDaXiao', 'zongHeDanShuang'],
    ballText: [
      { name: '第一球', val: 'hm1' },
      { name: '第二球', val: 'hm2' },
      { name: '第三球', val: 'hm3' },
      { name: '第四球', val: 'hm4' },
      { name: '第五球', val: 'hm5' },
      { name: '总和', val: 'all' }

    ],
    typeText: [
      { name: '单双', val: 'hmDanShuang' },
      { name: '大小', val: 'hmDaXiao' },
      { name: '龙虎', val: 'longHu' }
    ],
    singleBall: '第一球',
    singleType: '大小'
  },
  kl10: {
    singleBallData: ['第一球', '第二球', '第三球', '第四球', '第五球', '第六球', '第七球', '第八球', '总和'],
    singleTypeData: ['大小', '单双', '龙虎', '尾数大小', '合数单双', '中发白', '方位'],
    ballData: ['hm1', 'hm2', 'hm3', 'hm4', 'hm5', 'hm6', 'hm7', 'hm8', 'all', 'allmantissa'],
    typeData: ['hmDanShuang', 'hmDaXiao', 'zuLongHu', 'hmWeiShuDaXiao', 'hmHeDanShuang', 'zhongFaBai', 'fangWei'],
    ballText: [
      { name: '第一球', val: 'hm1' },
      { name: '第二球', val: 'hm2' },
      { name: '第三球', val: 'hm3' },
      { name: '第四球', val: 'hm4' },
      { name: '第五球', val: 'hm5' },
      { name: '第六球', val: 'hm6' },
      { name: '第七球', val: 'hm7' },
      { name: '第八球', val: 'hm8' },
      { name: '总和', val: 'all' }

    ],
    typeText: [
      { name: '单双', val: 'hmDanShuang' },
      { name: '大小', val: 'hmDaXiao' },
      { name: '龙虎', val: 'zuLongHu' },
      { name: '尾数大小', val: 'hmWeiShuDaXiao' },
      { name: '合数单双', val: 'hmHeDanShuang' },
      { name: '中发白', val: 'zhongFaBai' },
      { name: '方位', val: 'fangWei' }
    ],
    singleBall: '第一球',
    singleType: '大小'
  },
  kl8: {
    typeData: ['zongHeDaXiao', 'zongHeDanShuang', 'hmDaXiaoPan', 'hmDanShuangPan', 'wuXing'],
    typeText: [
      { name: '总和大小', val: 'zongHeDaXiao' },
      { name: '总合单双', val: 'zongHeDanShuang' },
      { name: '前后和', val: 'hmDaXiaoPan' },
      { name: '单双和', val: 'hmDanShuangPan' },
      { name: '总和五行', val: 'wuXing' }
    ]
  }
}

export {
  filterMapping
}

